// @flow

import React, { useState, useEffect, type Element } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  defaultOpen?: boolean,
  title: string | Element<any>,
  secondaryTitle?: string,
  action?: ?Element<any>,
  onToggle?: (isOpen: boolean) => void,
  onInteract?: () => void,
  children: Element<any>,
  locationHash?: string,
  listCustomClass?: string,
  headerCustomClass?: string,
  wrapperCustomClass?: string,
  primaryTitleCustomClass?: string,
  secondaryTitleCustomClass?: string,
};

const Collapsible = ({
  defaultOpen = false,
  locationHash,
  title,
  secondaryTitle,
  action,
  onToggle,
  onInteract,
  children,
  listCustomClass = '',
  headerCustomClass = '',
  wrapperCustomClass = '',
  primaryTitleCustomClass = '',
  secondaryTitleCustomClass = '',
}: Props) => {
  const history = useHistory();
  const { hash, pathname } = useLocation();
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    if (!open && locationHash && locationHash === hash) {
      setOpen(true);
    }
  }, [hash, open, locationHash]);

  const handleOnClick = () =>
    setOpen((currentState) => {
      const nextOpen = !currentState;
      if (currentState) {
        history.push({ pathname });
      }

      if (onToggle) {
        onToggle(nextOpen);
      }

      return nextOpen;
    });

  return (
    <List className={classNames(styles.list, listCustomClass)}>
      <ListItem className={classNames(styles.title, headerCustomClass)} button onClick={handleOnClick} disableRipple>
        <ListItemText className={primaryTitleCustomClass} primary={title} />
        {secondaryTitle && (
          <ListItemText
            className={classNames(styles.secondaryTitle, secondaryTitleCustomClass)}
            primary={secondaryTitle}
          />
        )}
        <div className={styles.arrow}>
          {action && (
            <div role="presentation" className={styles.action} onClick={(e) => e.stopPropagation()}>
              {action}
            </div>
          )}
          {open ? <ExpandLess /> : <ExpandMore />}
        </div>
      </ListItem>
      <Collapse in={open} timeout="auto" classes={{ wrapper: classNames(styles.collapseWrapper, wrapperCustomClass) }}>
        <div
          onClickCapture={() => {
            if (open && onInteract) onInteract();
          }}
          onFocusCapture={() => {
            if (open && onInteract) onInteract();
          }}
        >
          {children}
        </div>
      </Collapse>
    </List>
  );
};

export default Collapsible;
